export default "__VITE_ASSET__BHVLkhHB__"